import axiosInstance from "../../api/axiosInstance";

export const getEmailPreferences = async () => {
  try {
    const res = await axiosInstance.get("/client/email-preferences");
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null };
  }
};

export const updateEmailPreferences = async (prefs) => {
  try {
    const res = await axiosInstance.put("/client/email-preferences", prefs);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: null };
  }
};
